/* eslint-disable @nx/enforce-module-boundaries */
import { ValueGetterParams } from '@ag-grid-community/core';
import { FieldType } from '@heitown/common-interfaces';
import { FilterConfig } from './filter-config';
import { SelectItem } from './select-item';

export interface EntityListField extends FilterConfig {
  hideFilter?: boolean;
  initialHideColumn?: boolean;
  hideColumn?: boolean;
  fieldType?: FieldType;
  elementValues?: SelectItem[];
  exportHideColumn?: boolean;
  valueGetter?: (params: ValueGetterParams<any>) => any;
  minWidth?: number;
  maxWidth?: number;
}
